import { PROMOTION_METHODS_RECEIVED } from '../../actions/product-management/GetPromotionMethods';

const initialState = [];

const promotionMethods = (state = initialState, action) => {
  switch (action.type) {
    case PROMOTION_METHODS_RECEIVED:
      return action.promotionMethods;
  }

  return state;
};

export default promotionMethods;
